import React, { useEffect, useState } from 'react';

const AnimatedArrows = props => {

	const { animateLeft, speed, arrowCount } = props;

	const [numOfArrows, setNumOfArrows] = useState(arrowCount || 7);
	const [animationSpeed, setAnimationSpeed] = useState(speed || 6);
	const [arrowChar, setArrowChar] = useState((!!animateLeft && "&rang;") || "&lang;");
	const [step, setStep] = useState(0);

	let timer;
	
	const getStyle = (count, offset=0, iter=3) => {
		const quotient = ((count + offset) % iter);
		return quotient === 1 ? {opacity: .5}: {};
	}
	
	const renderArrows = (new Array(numOfArrows)).fill(0).map((item, i)=><span key={'arrow'+i} style={getStyle(i+1, step)} dangerouslySetInnerHTML={{__html: arrowChar}} />);

	useEffect(()=>{
		timer = window.setTimeout(()=>{
			setStep(step+1);
		},1000);

		return ()=>{window.clearTimeout(timer);}
	},[step])

	return (
		<span className="animated-arrows">
			{renderArrows}
		</span>
		);
}

export default AnimatedArrows;


// WEBPACK FOOTER //
// ./src/components/AnimatedArrows.jsx